import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/** Narrows an `unknown` (e.g. a value caught from `.unwrap()`) to an RTK
 *  Query `FetchBaseQueryError`. The other thing `.unwrap()` can throw is a
 *  `SerializedError`, which lacks `status` and gets cleanly rejected here. */
export const isFetchError = (err: unknown): err is FetchBaseQueryError => typeof err === 'object' && err !== null && 'status' in err;

export const isNotFoundError = (error: FetchBaseQueryError): boolean => {
    return error.status === 404;
};

export const isConflictError = (error: FetchBaseQueryError): boolean => {
    return error.status === 409;
};
